import { State } from "../types/store";

export const selectOptions = (state: State) => state.options.options;
export const selectOptionsDisabled = (state: State) => state.options.disabled;
